import Papa from 'papaparse';
import { useEffect, useState } from 'react';

export const useParseCsv = (file?: File | null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<Papa.ParseResult<string[]> | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);

  useEffect(() => {
    if (!file || isLoading) {
      return;
    }

    setIsLoading(true);
    Papa.parse<string[]>(file, {
      header: false,
      skipEmptyLines: true,
      transformHeader: (header) => header.trim(),
      complete: (result) => {
        setResult(result);
        setIsLoading(false);
      },
      error: (error) => {
        setError(error);
        setIsLoading(false);
        setResult(undefined);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  return {
    result,
    isLoading,
    error,
    isValid: result?.errors.length === 0 && !error,
    isError: !!error || (result?.errors.length ?? 0) > 0,
  };
};
